import { useLocation } from 'react-router-dom';
import { DOCTORS_ROUTE } from '../constants/routes';
import { useFeeChangeNoticeVisible } from './useFeeChangeNotice';

export const useFeeChangeNoticeOnPsychologistList = (): boolean => {
  const { pathname } = useLocation();
  const isWithinWindow = useFeeChangeNoticeVisible();

  return isWithinWindow && (pathname === DOCTORS_ROUTE || pathname === `${DOCTORS_ROUTE}/`);
};
